import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import LatestMovies from './components/LatestMovies';
import HotRanking from './components/HotRanking';
import ArticleRecommend from './components/ArticleRecommend';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '花生影院',
      url: 'https://www.huahuashengcinema.com',
      description: '花生影院打造全面电影大全库，涵盖最新电影、经典影片资源，支持高清免费在线观看不缓冲播放，提供电影排行榜供用户选择。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-6688',
        contactType: 'customer service',
        availableLanguage: 'Chinese',
      },
    },
    {
      '@type': 'WebSite',
      name: '花生影院',
      url: 'https://www.huahuashengcinema.com',
      description: '花生影院打造全面电影大全库，涵盖最新电影、经典影片资源，支持高清免费在线观看不缓冲播放。',
      potentialAction: {
        '@type': 'SearchAction',
        'target': 'https://www.huahuashengcinema.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '花生影院 - 首页',
      url: 'https://www.huahuashengcinema.com/',
      description: '花生影院首页，提供最新电影推荐、热门排行榜、精选影评文章。',
      isPartOf: {
        '@type': 'WebSite',
        name: '花生影院',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEO
        title="花生影院 | 电影大全 | 最新电影免费在线观看高清不缓冲"
        description="花生影院打造全面电影大全库，涵盖最新电影、经典影片资源，支持高清免费在线观看不缓冲播放，提供电影排行榜供用户选择。"
        keywords="花生影院,电影大全,电影资源,最新电影,电影在线,电影排行榜,免费在线观看,高清,不缓冲"
        canonicalUrl="https://www.huahuashengcinema.com/"
        ogType="website"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryNav />
        <LatestMovies />
        <HotRanking />
        <ArticleRecommend />
      </main>
      <Footer />
    </>
  );
}